/**
 * isLocalhost - true when running against the local dev server, where index.js starts the MSW
 * backend + Zoom SDK mocks (src/localtest/mocks). Prefix match, so it holds with any path or
 * scenario query string. Guards on `typeof window` so it is safe outside a browser.
 */
export const isLocalhost = () =>
  typeof window !== "undefined" && window.location.href.startsWith("http://localhost:3000");
